







































import {Component, Emit, Ref, Vue, Watch} from 'vue-property-decorator'
import type {ComponentPayload} from '@/store/shots'
import type {StageParameters} from 'ngl'
import MoleculesChooser from '@/components/NGL/MoleculesChooser.vue'

export const NGLStagePreviewParams: Partial<StageParameters> = {
  impostor: true,
  clipMode: 'camera',
  clipScale: 'absolute',
  clipNear: 0.01,
  clipFar: 100000,
  fogNear: 0.01,
  fogFar: 100000,
  lightIntensity: 1,
  ambientIntensity: 1,
}

@Component({
  name: 'MoleculesDialog',
  components: {
    MoleculesChooser,
  }
})
export default class MoleculesDialog extends Vue {
  @Ref() moleculesChooser!: MoleculesChooser
  dialogOpen = false
  loadingData = false
  newComponents: ComponentPayload[] = []

  @Watch('dialogOpen')
  dialogOpenWatcher(newVal: boolean) {
    if (newVal && this.$refs.moleculesChooser)
      (this.$refs.moleculesChooser as any).reset()
  }

  onComponentAdded(component: ComponentPayload) {
    this.newComponents.push(component)
  }

  onComponentRemoved({component = '', index = -1}) {
    this.newComponents.splice(index, 1)
  }

  @Emit('componentsAdded')
  save() {
    console.log('MoleculesDialog.save()')

    const newComponents = this.newComponents
    this.dialogOpen = false
    this.newComponents = []

    return newComponents
  }

  cancel() {
    console.log('MoleculesDialog.cancel()')
    this.dialogOpen = false
    this.newComponents = []
  }

  onDialogClickOutside() {
    console.log('MoleculesDialog.onDialogClickOutside()')
  }

  get okBtnDisabled(): boolean {
    return this.newComponents.length <= 0
  }
}
